











































































import {computed, defineComponent, PropType} from "@vue/composition-api";
import FormSection from "@tool/Components/FormSection.vue";
import useFormHelper from "@tool/Helpers/useFormHelper";
import {TeamEntityInterface, TeamInvitationEntityInterface} from "@tool/tool.types";
import FormError from "@tool/Components/FormError.vue";
import {WithProps} from "@base/base.types";
import useAxios, {axiosErrorTransformer} from "@tool/Helpers/useAxios";
import {useInertia} from "@tool/Helpers/useInertia";
import useVuelidate from "@vuelidate/core";
import {email, helpers, minLength, required} from "@vuelidate/validators";
import InputErrors from "@tool/Components/InputErrors.vue";
import {validateState} from "@base/base.helpers";
import useSwal from "@tool/Helpers/useSwal";
import useAppStore from "@tool/store/useAppStore";
import useInertiaData from "@tool/Helpers/useInertiaData";

export default defineComponent({
    components: {
        FormSection,
        FormError,
        InputErrors,
    },
    props: {
        team: {
            type: Object as PropType<WithProps<TeamEntityInterface, 'members' | 'invitations'>>,
            required: true
        }
    },
    setup(props) {
        const inertiaData = useInertiaData();
        const user = inertiaData.value.user;

        const userIsTeamAdmin = computed(() => {
            return user.id === props.team.owner_user_id;
        })

        const form = useFormHelper({
            name: '',
            email: '',
        });

        const formValidator = useVuelidate({
            name: {
                required,
                minLength: helpers.withMessage('First name should be at least 2 characters long', minLength(2))
            },
            email: {
                required,
                email
            }
        }, form.value.data);

        const formHandle = async () => {

            const response = await form.value.submit((data) => {
                return useAxios().post<TeamInvitationEntityInterface>(route('app.team.invitations.store', props.team.id), {
                    name: data.name,
                    email: data.email
                })
            });

            if (response.success) {
                useInertia().get(route(route().current(), route().params), {}, {
                    preserveScroll: true,
                    onSuccess() {
                        useSwal().fire('Invitation Sent!', 'Invitation has been sent to ' + form.value.data.email + ' email.', 'success')
                        form.value.reset();
                    }
                });
            }
        }

        const teamMemberRemove = async (member: WithProps<TeamEntityInterface, 'members'>['members'][0]) => {
            await useSwal().fire({
                title: 'Are you sure?',
                html: 'Are you sure you want to remove <b>' + member.name_first + '</b> from this team?',
                icon: "question",
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                preConfirm() {
                    return useAxios().delete<{ success: true }>(route('app.team.member.destroy', {
                        tool_team_entity: props.team.id,
                        tool_team_membership_entity: member.membership.id
                    }))
                            .then(() => {
                                return new Promise(resolve => {
                                    useInertia().get(route(route().current(), route().params), {}, {
                                        preserveScroll: true,
                                        onFinish() {
                                            resolve(true);
                                        }
                                    });
                                })

                            })
                            .catch(error => {
                                const axiosError = axiosErrorTransformer(error);
                                useSwal().showValidationMessage(axiosError.message)
                            });
                }
            }).then(response => {
                if (response.isConfirmed) {
                    useSwal().fire('Removed!', member.name_first + ' has been removed from this team!', 'success');
                }
            });
        }

        const invitationCancel = async (invitation: WithProps<TeamEntityInterface, 'invitations'>['invitations'][0]) => {
            await useSwal().fire({
                title: 'Are you sure?',
                text: 'Are you sure you want to cancel sent invitation?',
                icon: "question",
                showCancelButton: true,
                confirmButtonText: 'Confirm!',
                preConfirm() {
                    return useAxios().delete<{ success: true }>(route('app.team.invitation.destroy', {
                        tool_team_entity: props.team.id,
                        tool_team_invitation_entity: invitation.id
                    }))
                            .then(() => {
                                return new Promise(resolve => {
                                    useInertia().get(route(route().current(), route().params), {}, {
                                        preserveScroll: true,
                                        onFinish() {
                                            resolve(true);
                                        }
                                    });
                                })

                            })
                            .catch(error => {
                                const axiosError = axiosErrorTransformer(error);
                                useSwal().showValidationMessage(axiosError.message);
                            });
                }
            }).then(response => {
                if (response.isConfirmed) {
                    useSwal().fire('Cancelled!', 'Invitation has been cancelled!', 'success');
                }
            });

        }

        return {
            userIsTeamAdmin,

            form,
            formValidator,
            formHandle,
            validateState,

            teamMemberRemove,
            invitationCancel,
        }
    }
});
